/**
 * Application constants
 */

// Local storage keys for data persistence
export const STORAGE_KEYS = {
  USER_PROFILE: 'user_profile',
  PROFILE_DATA: 'profile_data',
  EXPANDED_SECTIONS: 'expanded_sections',
  THEME: 'ui_theme',
  VERSIONS: 'versions',
  SELECTED_VERSION: 'selected_version',
  FLOATING_CONTROLS_POSITION: 'floatingControlsPosition',
  TESTING_ENVIRONMENT: 'testing_environment_enabled',
  AUTH_TOKEN: 'auth_token',
  // Admin mode PIN flag (Settings page feature — not related to the retired /admin route)
  ADMIN_MODE: 'admin_mode_enabled'
} as const;

// Default IDs for protected items
export const DEFAULT_IDS = {
  MEMBER_ID: 'anonymized_member', // Replace numerical ID with anonymized value
  ACCOUNT_ID: 'anonymized_account', // Replace numerical ID with anonymized value
  WALLET_ASSET_ID: 'default_wallet_asset',
  USER_PROJECT_WALLET_ID: 'project_olivia_user_wallet'
} as const;

// API endpoints for external services
export const API_ENDPOINTS = {
  GET_USER_PROFILE: '/api/user/profile'
} as const;

// UI-related constants
export const UI = {
  TRANSITIONS: {
    DEFAULT: '0.2s ease',
    FAST: '0.15s ease',
    SLOW: '0.3s ease-in-out'
  },
  CONTROLS: {
    FLOATING_PANEL_Z_INDEX: 100,
    TOOLTIP_Z_INDEX: 1000,
    MODAL_Z_INDEX: 2000
  },
  COLORS: {
    PRIMARY: 'var(--brand-gold-alt)',
    SECONDARY: 'var(--brand-text-secondary)',
    SUCCESS: '#28a745',
    WARNING: '#ffc107',
    DANGER: '#dc3545'
  }
} as const;

// Legacy UI constants for backward compatibility
export const UI_CONSTANTS = {
  SNAP_THRESHOLD: 120,
  STRONG_SNAP_THRESHOLD: 60,
  VIEWPORT_MARGIN: 20,
  WIDTH: 320,
  HEIGHT: 56,
  MAX_VERSIONS_DISPLAY: 10,
  CONTROL_WIDTH: 320,
  CONTROL_HEIGHT: 56
} as const;

// Section names for consistent references
export const SECTIONS = {
  MEMBERS: 'members',
  ACCOUNTS: 'accounts',
  TOOLS: 'tools',
  TRIGGERS: 'triggers',
  RESOURCES: 'resources',
  ASSETS: 'assets',
  POLICIES: 'policies',
  PROCEDURES: 'procedures',
  AUTONOMY: 'autonomy',
  EXAMPLES: 'examples',
  BEHAVIORS: 'behaviors',
  SITUATIONS: 'situations'
} as const; 